import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import CustomNavigate from '../components/CustomNavigate';

export default function LoggedMiddleware({ children }) {
    const { user } = useAuth();

    if (!user) return <CustomNavigate to="/auth/login" />;
    return children;
}

LoggedMiddleware.propTypes = {
    children: PropTypes.node.isRequired,
};
